
export const APPLICANT_SUCCESS = 'APPLICANT_SUCCESS'
